<template>
  <div>
    <div class="el-icon-minus tab-btn" @click="setWinMin" />
    <span class="tab-btn" v-show="winStatus === 'max'" @click="setWinUnMax"><icon>chuangkouzuidahua2</icon></span>
    <span class="tab-btn" v-show="winStatus === 'normal'" @click="setWinMax"><icon>chuangkouquanping1</icon></span>
    <div class="el-icon-close tab-btn tab-btn-close" @click="setWinClose" />
  </div>
</template>

<script>
export default {
  name: "winCtrl",
  data() {
    return {
      winStatus: undefined,
    }
  },
  mounted() {
    let self = this

    this.winStatus = this.utils.electron.getFocusedWinStatus()
    console.log("win32Ctrl this.winStatus:", this.winStatus)

    this.utils.electron.winStatusUpdateHandlerAdd((status) => { self.winStatus = status })
  },
  methods: {
    setWinMin: function() {
      this.utils.electron.setWinMin()
    },
    setWinMax: function() {
      this.utils.electron.setWinMax()
    },
    setWinUnMax: function() {
      this.utils.electron.setWinUnMax()
    },
    setWinClose: function() {
      this.utils.electron.setWinClose()
    }
  },
}
</script>

<style scoped>
.tab-btn {
  color: #c6c6c6;
  padding: 8px;
}
.tab-btn:hover {
  color: white;
  background: #333333;
}
.tab-btn:active {
  color: white;
  background: #111;
}
.tab-btn-close:hover {
  background: #ff8585;
}
.tab-btn-close:active {
  background: #ff8585;
}
</style>
